"use client";

import { c as _c } from "react/compiler-runtime";
import { resolveIpfsUrl } from "@/components/ipfs/IPFSContext";
import ArtistProfileHandle from "@/components/the-memes/ArtistProfileHandle";
import type { BaseNFT } from "@/entities/INFT";
import { useIdentity } from "@/hooks/useIdentity";
import Image from "next/image";
import Link from "next/link";
interface NowMintingHeaderProps {
  readonly cardNumber: number;
  readonly title: string;
  readonly artistHandle: string;
  readonly artistName: string;
}
function NowMintingArtistHandlePill(t0) {
  const $ = _c(12);
  const {
    artistHandle
  } = t0;
  let t1;
  if ($[0] !== artistHandle) {
    t1 = {
      handleOrWallet: artistHandle,
      initialProfile: null
    };
    $[0] = artistHandle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  let t2;
  if ($[2] !== artistHandle || $[3] !== profile) {
    t2 = profile?.pfp ? <Image src={resolveIpfsUrl(profile.pfp)} alt={artistHandle} width={16} height={16} className="tw-size-4 tw-flex-shrink-0 tw-rounded-sm tw-bg-iron-900 tw-object-contain" /> : <div className="tw-size-4 tw-flex-shrink-0 tw-rounded-sm tw-bg-iron-900 tw-object-contain" />;
    $[2] = artistHandle;
    $[3] = profile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== artistHandle) {
    t3 = {
      artist_seize_handle: artistHandle
    };
    $[5] = artistHandle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = t3 as BaseNFT;
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="tw-text-sm tw-font-medium tw-text-iron-200 tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-iron-100"><ArtistProfileHandle nft={t4} /></span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <span className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-2.5 tw-py-1 tw-backdrop-blur-sm">{t2}{t5}</span>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function NowMintingArtistNamePill(t0) {
  const $ = _c(3);
  const {
    artistName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-size-4 tw-flex-shrink-0 tw-rounded-sm tw-bg-iron-900 tw-object-contain" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== artistName) {
    t2 = <span className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-2.5 tw-py-1 tw-backdrop-blur-sm">{t1}<span className="tw-text-sm tw-font-medium tw-text-iron-200">{artistName}</span></span>;
    $[1] = artistName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default function NowMintingHeader(t0) {
  const $ = _c(22);
  const {
    cardNumber,
    title,
    artistHandle,
    artistName
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== artistHandle || $[1] !== artistName || $[2] !== cardNumber || $[3] !== title) {
    const artistHandles = artistHandle.split(",").map(_temp).filter(Boolean);
    t4 = "tw-flex tw-flex-col";
    const t6 = `/the-memes/${cardNumber}`;
    if ($[9] !== t6 || $[10] !== title) {
      t5 = <Link href={t6} className="tw-text-xl tw-font-semibold tw-leading-tight tw-text-iron-50 tw-no-underline tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-iron-200 sm:tw-text-2xl md:tw-text-3xl">{title}</Link>;
      $[9] = t6;
      $[10] = title;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t1 = "tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-2";
    if ($[12] !== cardNumber) {
      t2 = <span className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-[0.08em] tw-text-iron-400 tw-backdrop-blur-sm">Card #{cardNumber}</span>;
      $[12] = cardNumber;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    t3 = artistHandles.length > 0 ? artistHandles.map(_temp2) : <NowMintingArtistNamePill artistName={artistName} />;
    $[0] = artistHandle;
    $[1] = artistName;
    $[2] = cardNumber;
    $[3] = title;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t6 = <div className={t1}>{t2}{t3}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp2(handle_0) {
  return <NowMintingArtistHandlePill key={handle_0} artistHandle={handle_0} />;
}
function _temp(handle) {
  return handle.trim();
}